module.exports = __webpack_public_path__ + "static/admindemo-9205ebb329369f84c5187757483f7990.mp4";